import { lazy, Suspense } from 'react';
import { Route } from 'react-router';
import { routePathsHome } from 'core/lib/routePaths/homeRoutePaths';
import { RouteLoader } from '#components/Loader/RouteLoader';

const PortalHome = lazy(() => import('home/central-routes/home-routes'));

const SupportRoute = lazy(() =>
  import('home/central-routes/home-routes').then((module) => ({
    default: module.SupportRoute,
  })),
);

const Health = lazy(() =>
  import('home/central-routes/home-routes').then((module) => ({
    default: module.HealthRoute,
  })),
);

const SubscriptionsOverview = lazy(() =>
  import('home/central-routes/home-routes').then((module) => ({
    default: module.SubscriptionsOverviewRoute,
  })),
);

export const PortalHomeRouteTree = [
  <Route
    key={0}
    path={routePathsHome.HOME}
    index
    element={
      <Suspense fallback={<RouteLoader />}>
        <PortalHome />
      </Suspense>
    }
  />,
  <Route
    key={1}
    path={routePathsHome.HEALTH}
    element={
      <Suspense fallback={<RouteLoader />}>
        <Health />
      </Suspense>
    }
  />,
  <Route
    key="subscriptions-overview"
    path={routePathsHome.SUBSCRIPTIONS_OVERVIEW}
    element={
      <Suspense fallback={<RouteLoader />}>
        <SubscriptionsOverview />
      </Suspense>
    }
  />,
  <Route key={2} path={routePathsHome.SUPPORT}>
    <Route
      key={0}
      index
      element={
        <Suspense fallback={<RouteLoader />}>
          <SupportRoute />
        </Suspense>
      }
    />
    <Route
      key={1}
      path={routePathsHome.CONTACT}
      element={
        <Suspense fallback={<RouteLoader />}>
          <SupportRoute />
        </Suspense>
      }
    />
    <Route
      key={2}
      path={routePathsHome.RELEASE_NOTES}
      element={
        <Suspense fallback={<RouteLoader />}>
          <SupportRoute />
        </Suspense>
      }
    />
    <Route
      key={3}
      path={routePathsHome.API_DOCUMENTATION}
      element={
        <Suspense fallback={<RouteLoader />}>
          <SupportRoute />
        </Suspense>
      }
    />
  </Route>,
];

export const preloadPortalHome = () => {
  //Import default export to trigger preload
  void import('home/central-routes/home-routes');
};
